// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  mapName: __t.string().name("map_name"),
  width: __t.f64(),
  height: __t.f64(),
  cellSize: __t.f64().name("cell_size"),
  cols: __t.u32(),
  rows: __t.u32(),
  walkableCount: __t.u32().name("walkable_count"),
  tick: __t.u64(),
  phase: __t.string(),
  createdAt: __t.timestamp().name("created_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
